import { render } from "./UXfolioLogo.vue?vue&type=template&id=4eefcc1e&scoped=true"
import script from "./UXfolioLogo.vue?vue&type=script&lang=js"
export * from "./UXfolioLogo.vue?vue&type=script&lang=js"

import "./UXfolioLogo.vue?vue&type=style&index=0&id=4eefcc1e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eefcc1e"],['__file',"src/scripts/view/publicPages/icons/UXfolioLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4eefcc1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eefcc1e', __exports__)) {
    api.reload('4eefcc1e', __exports__)
  }
  
  module.hot.accept("./UXfolioLogo.vue?vue&type=template&id=4eefcc1e&scoped=true", () => {
    api.rerender('4eefcc1e', render)
  })

}


export default __exports__